import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Compass, PlusCircle, Sparkles, MessageCircle, User } from "lucide-react";

const TABS = [
  { to: "/home", icon: Home, label: "Home", id: "home" },
  { to: "/discover", icon: Compass, label: "Discover", id: "discover" },
  { to: "/post", icon: PlusCircle, label: "Post", id: "post", center: true },
  { to: "/matches", icon: Sparkles, label: "Matches", id: "matches" },
  { to: "/messages", icon: MessageCircle, label: "Chats", id: "messages" },
  { to: "/profile", icon: User, label: "Profile", id: "profile" },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 z-40 w-full max-w-[480px] -translate-x-1/2 border-t border-gray-100 bg-white/95 px-2 pb-[env(safe-area-inset-bottom)] pt-2 shadow-nav backdrop-blur-2xl">
      <div className="flex items-center justify-between">
        {TABS.map((t) => (
          <NavLink
            key={t.id}
            to={t.to}
            data-testid={`bottom-nav-${t.id}`}
            className="flex flex-1 flex-col items-center gap-0.5 py-1"
          >
            {({ isActive }) =>
              t.center ? (
                <div className={`grid h-12 w-12 -translate-y-3 place-items-center rounded-2xl bg-brand text-white shadow-brand transition-transform active:scale-90 ${isActive ? "ring-4 ring-brand-light" : ""}`}>
                  <t.icon className="h-6 w-6" strokeWidth={2.2} />
                </div>
              ) : (
                <>
                  <t.icon className={`h-5.5 w-5.5 transition-colors ${isActive ? "text-brand" : "text-ink-soft/60"}`} style={{ width: 22, height: 22 }} strokeWidth={isActive ? 2.6 : 2} />
                  <span className={`text-[10px] font-semibold ${isActive ? "text-brand" : "text-ink-soft/60"}`}>{t.label}</span>
                </>
              )
            }
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
